import { schema } from "normalizr";
export const documentSchema = new schema.Entity(
  "documents",
  {},
  {
    idAttribute: "documentId",
  }
);
export const documentListSchema = [documentSchema];
